import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

import { TimeScale } from 'src/api/models/invoices';

const InvoicesListSearchParams = createPaginationSchema()
  .concat(
    createSortSchema(['invoiceId', 'vendorName', 'invoiceDate', 'invoiceTotal', 'purchaseOrder'])
  )
  .concat(
    Yup.object({
      distributors: Yup.string().optional(),
      buyerOrgIds: Yup.string().optional(),
      startDate: Yup.string().optional(),
      endDate: Yup.string().optional(),
      timeScale: Yup.mixed<TimeScale>()
        .oneOf(['day', 'week', 'month', 'quarter', 'year'] as const)
        .default('month'),
      tab: Yup.string().optional(),
    })
  );

export default InvoicesListSearchParams;
